module.exports = __webpack_public_path__ + "static/media/Forbidden-red Icon.807c3bb0.png";